import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

import { BufferingComponent } from '../../../ui/buffering/buffering.component';
import { CheckboxComponent } from '../../../ui/checkbox/checkbox.component';
import { BaseModalComponent } from '../../base-modal/base-modal.component';

@Component({
  selector: 'mb-embargo-confirm-modal',
  templateUrl: './embargo-confirm-modal.component.html',
  styleUrls: ['./embargo-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseModalComponent, BufferingComponent, TranslatePipe, TranslateDirective, CheckboxComponent, AsyncPipe],
})
export class EmbargoConfirmModalComponent {
  public confirmed = false;
  @Input() formattedDatetimes: string[] = [];
  @Input() isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @Output() confirm = new EventEmitter<{ remember: boolean }>();
  @Output() requestCancel = new EventEmitter();
}
